
import { Vue } from 'vue-class-component'

export default class ObjectSwitchingTimes extends Vue {
    headline = "Schaltzeiten"
}
